import { axiosInstance } from '@/core/services';
import {
  StudyListItem,
  StudyDetail,
  PreviewTokenResponse,
} from '@aphp-ema/common/study';

const API_BASE_URL =
  (import.meta.env.VITE_API_URL as string) || 'http://localhost:3000/api';

export const createDraftStudy = async (): Promise<StudyListItem> => {
  const response = await axiosInstance.post(`${API_BASE_URL}/admin/studies`);

  return response.data;
};

export const publishStudy = async (studyId: string): Promise<StudyListItem> => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}/admin/studies/${studyId}/publish`,
  );

  return response.data;
};

export const unpublishStudy = async (studyId: string): Promise<StudyDetail> => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}/admin/studies/${studyId}/unpublish`,
  );

  return response.data;
};

export const generatePreviewToken = async (
  studyId: string,
): Promise<PreviewTokenResponse> => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}/admin/studies/${studyId}/preview-token`,
  );

  return response.data;
};

export const duplicateStudy = async (studyId: string): Promise<StudyDetail> => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}/admin/studies/${studyId}/duplicate`,
  );

  return response.data;
};
